import styled, { css } from 'styled-components'

import CheckBox, { CheckboxProps } from '@mui/material/Checkbox'

export const CheckboxStyled = styled(CheckBox)<CheckboxProps>(
  ({ theme }) => css`
    && {
      color: ${theme.colors.primary.main};

      &.Mui-checked {
        color: ${theme.colors.primary.main};
      }
    }
  `
)
